const BASE = '/api/student';

function authHeaders() {
  const token = sessionStorage.getItem('af_token');
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
}

async function req(method, path, body) {
  const res = await fetch(BASE + path, {
    method,
    headers: authHeaders(),
    body: body ? JSON.stringify(body) : undefined,
  });
  const ct   = res.headers.get('content-type') || '';
  const data = ct.includes('application/json') ? await res.json() : {};
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`);
  return data;
}

export const getStudentDashboard = ()                         => req('GET',  '/dashboard');
export const getStudentCourse    = (courseId)                 => req('GET',  `/courses/${courseId}`);
export const getModuleDetail     = (courseId, moduleId)       => req('GET',  `/courses/${courseId}/modules/${moduleId}`);
export const markModuleComplete  = (courseId, moduleId)       => req('POST', `/courses/${courseId}/modules/${moduleId}/complete`);
export const submitQuiz          = (courseId, moduleId, body) => req('POST', `/courses/${courseId}/modules/${moduleId}/quiz`, body);
export const resubmitAssignment  = (courseId, assignId)       => req('DELETE', `/courses/${courseId}/assignments/${assignId}/submit`);
export const renameSubmission    = (courseId, assignId, name) => req('PATCH',  `/courses/${courseId}/assignments/${assignId}/rename`, { file_name: name });

/** Upload a real file (multipart/form-data) */
export async function submitAssignment(courseId, assignId, file) {
  const token = sessionStorage.getItem('af_token');
  const fd = new FormData();
  fd.append('file', file);
  const res  = await fetch(`${BASE}/courses/${courseId}/assignments/${assignId}/submit`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: fd,
  });
  const ct   = res.headers.get('content-type') || '';
  const data = ct.includes('application/json') ? await res.json() : {};
  if (!res.ok) throw new Error(data.error || `Upload failed (${res.status})`);
  return data;
}

/** Trigger browser download of the student's own submitted file */
export async function downloadSubmission(courseId, assignId, fileName) {
  const token = sessionStorage.getItem('af_token');
  const res = await fetch(`${BASE}/courses/${courseId}/assignments/${assignId}/download`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Download failed');
  }
  const blob = await res.blob();
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement('a');
  a.href     = url;
  a.download = fileName || 'submission';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
